import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification-component"
}
const _hoisted_2 = {
  class: "notifications",
  id: "notifications"
}
const _hoisted_3 = { class: "notifications__main" }
const _hoisted_4 = { class: "notifications__header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "mobile-header-title",
  ref: "test"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-left" })
], -1)
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-right" })
], -1)
const _hoisted_14 = { class: "notifications__position" }
const _hoisted_15 = { class: "prev" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "slash" }, "/", -1)
const _hoisted_17 = { class: "all" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1)
const _hoisted_19 = { class: "notifications__body" }
const _hoisted_20 = { class: "notifications__body-inner" }
const _hoisted_21 = { class: "notifications__footer" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-left" })
], -1)
const _hoisted_24 = { class: "notifications__position" }
const _hoisted_25 = { class: "prev" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "slash" }, "/", -1)
const _hoisted_27 = { class: "all" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-right" })
], -1)
const _hoisted_30 = {
  class: "notifications__sidebar",
  style: { zIndex: 5 }
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("svg", { class: "sprite-icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#close" })
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "notifications__header" }
const _hoisted_35 = { class: "notifications__header-title" }
const _hoisted_36 = {
  key: 0,
  class: "notifications__header-mark"
}
const _hoisted_37 = { class: "notifications__sidebar-inner" }
const _hoisted_38 = { class: "notifications-summary overscroll" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "h6 notifications-summary__title" }
const _hoisted_41 = { class: "notifications-summary__text line-3-truncate" }
const _hoisted_42 = { class: "notifications-summary__bottomline" }
const _hoisted_43 = { href: "#" }
const _hoisted_44 = { class: "text-gray" }
const _hoisted_45 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_notification_details = _resolveComponent("notification-details")!

  return (_ctx.model.initialized)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
            class: "notifications__overlay"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSidebar && _ctx.openSidebar(...args))),
                class: _normalizeClass(["mobile-trigger-summary menu-trigger c-pointer", {
                            'mobile-trigger-summary_has-new':
                                _ctx.model.totalUnreadNews.value !== 0,
                        }])
              }, _hoisted_6, 2),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_i18n_t, { keypath: "notifications.newsHighlights" })
              ], 512),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:active', false))),
                class: "mobile-notification-close c-pointer"
              }, _hoisted_9),
              _createElementVNode("a", {
                onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.model.prev && _ctx.model.prev(...args)), ["prevent"])),
                class: "notifications__btn notifications__btn_prev",
                disabled: _ctx.model.isFirstNotificationSelected.value
              }, [
                _hoisted_11,
                _createElementVNode("span", null, [
                  _createVNode(_component_i18n_t, { keypath: "notifications.prev" })
                ])
              ], 8, _hoisted_10),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.model.next && _ctx.model.next(...args)), ["prevent"])),
                class: "notifications__btn notifications__btn_next",
                disabled: _ctx.model.isLastNotificationSelected.value
              }, [
                _createElementVNode("span", null, [
                  _createVNode(_component_i18n_t, { keypath: "notifications.next" })
                ]),
                _hoisted_13
              ], 8, _hoisted_12),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.model.notificationDetailsIndex.value + 1), 1),
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.model.notificationDetailsResponse.value?.total), 1)
              ]),
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.model.hideNotificationDetails && _ctx.model.hideNotificationDetails(...args))),
                class: "notifications__main-close",
                href: "#"
              }, [
                _hoisted_18,
                _createElementVNode("span", null, [
                  _createVNode(_component_i18n_t, { keypath: "notifications.hideBtn" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.notificationsDetailsData
                                .value, (notificationDetail) => {
                  return (_openBlock(), _createBlock(_component_notification_details, {
                    key: notificationDetail.id,
                    active: 
                                _ctx.model.currentNotificationID.value ===
                                notificationDetail.id
                            ,
                    notificationDetails: notificationDetail
                  }, null, 8, ["active", "notificationDetails"]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("a", {
                onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.model.prev && _ctx.model.prev(...args)), ["prevent"])),
                class: "notifications__btn notifications__btn_prev",
                disabled: _ctx.model.isFirstNotificationSelected.value
              }, [
                _hoisted_23,
                _createElementVNode("span", null, [
                  _createVNode(_component_i18n_t, { keypath: "notifications.prev" })
                ])
              ], 8, _hoisted_22),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.model.notificationDetailsIndex.value + 1), 1),
                _hoisted_26,
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.model.notificationDetailsResponse.value?.total), 1)
              ]),
              _createElementVNode("a", {
                onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.model.next && _ctx.model.next(...args)), ["prevent"])),
                class: "notifications__btn notifications__btn_next",
                disabled: _ctx.model.isLastNotificationSelected.value
              }, [
                _createElementVNode("span", null, [
                  _createVNode(_component_i18n_t, { keypath: "notifications.next" })
                ]),
                _hoisted_29
              ], 8, _hoisted_28)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
              class: "notifications__close"
            }, [
              _createElementVNode("span", null, [
                _createVNode(_component_i18n_t, { keypath: "notifications.closeBtn" })
              ]),
              _hoisted_31
            ]),
            _createElementVNode("div", {
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
              class: "notifications-mobile__close-summary"
            }, _hoisted_33),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_i18n_t, { keypath: "notifications.newsHighlights" })
              ]),
              (_ctx.model.totalUnreadNews.value !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.model.totalUnreadNews.value), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.notificationsDetailsData
                                .value, (notificationDetail) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: notificationDetail.id,
                    onClick: ($event: any) => (_ctx.model.showNotificationDetails(notificationDetail.id)),
                    class: _normalizeClass(["notifications-summary__item", {
                                new: _ctx.model.isNew(notificationDetail.id),
                                'is-active':
                                    _ctx.model.currentNotificationID.value ===
                                    notificationDetail.id,
                            }]),
                    ref_for: true,
                    ref: "notificationItem"
                  }, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(notificationDetail.title), 1),
                    _createElementVNode("p", _hoisted_41, _toDisplayString(notificationDetail.content), 1),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("a", _hoisted_43, [
                        _createVNode(_component_i18n_t, { keypath: "notifications.readMoreBtn" })
                      ]),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.model.formattedCreatedDate(
                                            notificationDetail.created_at,
                                        )), 1)
                    ])
                  ], 10, _hoisted_39))
                }), 128)),
                (_ctx.model.canLoadMore.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      style: {"width":"100%"},
                      class: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.model.loadMore && _ctx.model.loadMore(...args))),
                      disabled: _ctx.model.isLoading.value
                    }, [
                      _createVNode(_component_i18n_t, { keypath: "notifications.loadMoreBtn" })
                    ], 8, _hoisted_45))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}